import { render, staticRenderFns } from "./MultiLanguage.vue?vue&type=template&id=6397833c&scoped=true"
import script from "./MultiLanguage.vue?vue&type=script&lang=js"
export * from "./MultiLanguage.vue?vue&type=script&lang=js"
import style0 from "./MultiLanguage.vue?vue&type=style&index=0&id=6397833c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397833c",
  null
  
)

export default component.exports